import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bolt",
  "use": "bolt-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"bolt\"><path d=\"M13 8V0L8.11 5.87 3 12h4v8L17 8h-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol